import React from "react";
import { CheckCircle, RefreshCw, Power } from "lucide-react";
import { cn } from "../lib/utils";
import { useAgentSessionStatusQuery } from "../api/jupyterManagementApi";

interface AgentStatusBadgeProps {
  projectId: string;
  className?: string;
  enabled?: boolean;
}

export function AgentStatusBadge({ projectId, className, enabled = true }: AgentStatusBadgeProps) {
  const { data: agentSessionStatus } = useAgentSessionStatusQuery(projectId, enabled);
  const agentStatus = agentSessionStatus?.status || "SLEEPING";

  return (
    <div className={cn(
      "w-full py-2.5 px-3 rounded-md border flex items-center justify-center gap-2 text-sm font-semibold transition-all shadow-sm",
      agentStatus === "CONNECTED" ? "bg-green-50 text-green-700 border-green-200" : 
      (agentStatus === "WAKE_PENDING" || agentStatus === "WAKING") ? "bg-amber-50 text-amber-700 border-amber-200" :
      "bg-slate-50 text-slate-500 border-slate-200",
      className
    )}>
      {agentStatus === "CONNECTED" ? (
        <><CheckCircle className="h-4 w-4 text-green-600" /> Agent Ready</>
      ) : (agentStatus === "WAKE_PENDING" || agentStatus === "WAKING") ? (
        <><RefreshCw className="h-4 w-4 animate-spin text-amber-600" /> Connecting Agent...</>
      ) : (
        <><Power className="h-4 w-4 text-slate-400" /> Agent Offline (Run Step 1)</>
      )}
    </div>
  );
}
